import React from 'react';
import { Table as BsTable } from 'react-bootstrap';
import styles from './Table.module.scss';

interface TableProps {
  id?: string;
  className?: string;
  headings?: React.ReactNode[];
  data: React.ReactNode[][];
  footering?: React.ReactNode[][];
}

const Table: React.FC<TableProps> = ({ id, className, headings, data, footering }) => {
  const columnCount = headings?.length || Math.max(
    ...data.map(row => row.length),
    ...(footering?.map(row => row.length) || [0])
  );

  const renderRow = (row: React.ReactNode[], keyPrefix: string) => {
    const fullCells = row.map((cell, cellIndex) => (
      <td key={`${keyPrefix}-cell-${cellIndex}`}>{cell}</td>
    ));

    if (row.length < columnCount) {
      const colSpan = columnCount - row.length + 1;
      const lastContent = row[row.length - 1];

      // Remove a última célula original
      fullCells.splice(-1, 1);

      // Adiciona nova célula com colSpan e key única
      fullCells.push(
        <td key={`${keyPrefix}-cell-spanned`} colSpan={colSpan}>
          {lastContent}
        </td>
      );
    }

    return <tr key={`${keyPrefix}-row`}>{fullCells}</tr>;
  };

  const tableId = id || 'table-' + Math.random().toString(36).substring(2, 15);

  return (
    <BsTable responsive bordered className={[styles.table, className].join(' ')} id={tableId}>
      {headings && (
        <thead>
          <tr>
            {headings.map((heading, idx) => (
              <th key={`${tableId}-heading-${idx}`}>{heading}</th>
            ))}
          </tr>
        </thead>
      )}
      <tbody>
        {data.map((row, rowIndex) => renderRow(row, `${tableId}-body-${rowIndex}`))}
      </tbody>
      {footering && footering.length > 0 && (
        <tfoot>
          {footering.map((row, rowIndex) => renderRow(row, `${tableId}-foot-${rowIndex}`))}
        </tfoot>
      )}
    </BsTable>
  );
};

export default Table;
